import React, { Component } from 'react';

import { HashRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { isMigrateArjTeamsToPlatformTeamsEnabled } from '@atlassian/jira-portfolio-3-portfolio/src/app-simple-plans/feature-flags';
import ExperienceTracker from './experience-tracker';
import FlagGroup from './flag-group';
import Onboarding from './onboarding';
import PlanPage from './plan-page';
import AsyncPlanConfigurationPage from './settings/async';
// delete this folder when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-global-styles -- Ignored via go/DSP-18766
import * as styles from './styles.module.css';
import TwpBenefitsModal from './twp-benefits-modal';
import type { Props } from './types';

// eslint-disable-next-line jira/react/no-class-components
export default class App extends Component<Props> {
	static defaultProps = {
		// Replace with lodash/noop
		// eslint-disable-next-line @typescript-eslint/no-empty-function
		onExperienceSuccess: () => {},
	};

	componentDidMount() {
		this.initializeApp();
		this.props.onExperienceSuccess && this.props.onExperienceSuccess();
		// Scope this global style to the ARJ package to prevent it leaking into other packages' storybooks
		window.document.body.style.overflowY = 'hidden';
	}

	componentDidUpdate(prevProps: Props) {
		if (this.props.planId !== prevProps.planId || this.props.scenarioId !== prevProps.scenarioId) {
			this.initializeApp();
		}
	}

	componentWillUnmount() {
		// Remove the inline styles
		if (window.document.body.style.overflowY === 'hidden') {
			window.document.body.style.overflowY = '';
		}
	}

	initializeApp() {
		const { locale, initialLoad, setInitialFilterValues } = this.props;

		initialLoad({ locale });
		setInitialFilterValues();
	}

	render() {
		return (
			// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
			<main className={styles.app} data-name="ManualPlans">
				<Onboarding />
				{/* delete this condition including code inside when removing the FF isMigrateArjTeamsToPlatformTeamsEnabled */}
				{isMigrateArjTeamsToPlatformTeamsEnabled() && <TwpBenefitsModal />}
				{/* @ts-expect-error - TS2769 - No overload matches this call. (Router type has no children) */}
				<Router hashType="noslash">
					<Switch>
						<Redirect to="/plan/backlog" from="/" exact />
						<Redirect to="/plan/backlog" from="/backlog" exact />
						<Route path="/plan" component={PlanPage} />
						<Route path="/settings" component={AsyncPlanConfigurationPage} />
					</Switch>
				</Router>
				<FlagGroup />
				<ExperienceTracker />
			</main>
		);
	}
}
